import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

function formatDateInput(ms) {
  if (ms == null) {
    return '';
  }
  return moment(ms).format('YYYY-MM-DD');
}

function formatTimeInput(ms) {
  if (ms == null) {
    return '';
  }
  return moment(ms).format('HH:mm');
}

export const DateTimeRow = ({
  date: startTimeMS,
  startTime: _startDup,
  endTime: endTimeMS,
  onRowAdd,
  onRowDelete,
  index,
  allowMultiple,
  onDateChange,
  onStartTimeChange,
  onEndTimeChange,
  readOnly = false,
}) => {
  const dateStr = formatDateInput(startTimeMS);
  const startTimeStr = formatTimeInput(startTimeMS);
  const endTimeStr = formatTimeInput(endTimeMS);

  return (
    <div className="festy-datetime-row flex w-full flex-wrap items-start gap-3">
      <div className="mr-[1.3rem]">
        <input
          type="date"
          className="festy-datetime-input"
          value={dateStr}
          disabled={readOnly}
          onChange={(e) => {
            const v = e.target.value;
            if (!v) {
              onDateChange(index, null);
              return;
            }
            const base = moment(v, 'YYYY-MM-DD').startOf('day');
            if (startTimeMS != null) {
              const prev = moment(startTimeMS);
              base
                .hour(prev.hour())
                .minute(prev.minute())
                .second(0)
                .millisecond(0);
            }
            onDateChange(index, base.valueOf());
          }}
        />
        <p className="m-0 pl-4 italic leading-normal text-[var(--festy-muted-text)]">
          Date
        </p>
      </div>
      <div className="mr-[1.3rem]">
        <input
          type="time"
          className="festy-datetime-input"
          value={startTimeStr}
          disabled={readOnly}
          onChange={(e) => {
            const t = e.target.value;
            if (!t) {
              onStartTimeChange(index, null);
              return;
            }
            const dayMs =
              startTimeMS != null
                ? moment(startTimeMS).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');
            const ms = moment(`${dayMs}T${t}`, 'YYYY-MM-DDTHH:mm').valueOf();
            onStartTimeChange(index, ms);
          }}
        />
        <p className="m-0 pl-4 italic leading-normal text-[var(--festy-muted-text)]">
          Start Time
        </p>
      </div>
      <div className="mr-[1.3rem]">
        <input
          type="time"
          className="festy-datetime-input"
          value={endTimeStr}
          disabled={readOnly}
          onChange={(e) => {
            const t = e.target.value;
            if (!t) {
              onEndTimeChange(index, null);
              return;
            }
            const dayMs =
              startTimeMS != null
                ? moment(startTimeMS).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');
            const ms = moment(`${dayMs}T${t}`, 'YYYY-MM-DDTHH:mm').valueOf();
            onEndTimeChange(index, ms);
          }}
        />
        <p className="m-0 pl-4 italic leading-normal text-[var(--festy-muted-text)]">
          End Time
        </p>
      </div>
      {allowMultiple && !readOnly && (
        <>
          <button
            type="button"
            className="border-none bg-white text-[1.3rem] text-[var(--festy-sky-blue)]"
            onClick={(e) => {
              e.preventDefault();
              onRowAdd();
            }}
          >
            <FontAwesomeIcon icon={['fas', 'circle-plus']} />
          </button>
          <button
            type="button"
            className="border-none bg-white text-[1.3rem] text-[var(--festy-sky-blue)]"
            onClick={(e) => {
              e.preventDefault();
              onRowDelete(index);
            }}
          >
            <FontAwesomeIcon icon={['far', 'trash-can']} />
          </button>
        </>
      )}
    </div>
  );
};
